import * as React from "react";
import { useRecordContext } from 'react-admin';
import { Button } from '@material-ui/core';

const BundlerSeatingRequestsButton = (props) => {
    const record = useRecordContext(props);
    const authToken = localStorage.getItem( 'authToken' );

    const bundlerSeatingRequests = `https://tables.paradigms.ontariopc.ca/seating.html?${record.event_id}-${record.person_hash}-${authToken}`;
    return ( <Button href={bundlerSeatingRequests}>Click Here</Button> );
}

BundlerSeatingRequestsButton.defaultProps = { label: 'Organize Tables' };

export default BundlerSeatingRequestsButton;
